<script>
  import { elasticOut } from 'eases-jsnext';
	import { fade, fly } from 'svelte/transition';

  export let accepted;
</script>
<style>
  ul {
      display: grid;
      grid-template-columns: repeat(6, 48px);
      justify-content: space-between;
      background: #fff;
      list-style: none;
      padding: 0;
      margin: 0;
  }
  li {
    padding: 0;
    background: none;
    background: #fff !important;
  }
  img {
      border-radius: .2rem;
      border: 1px solid #e3e0e0;
      box-sizing: border-box;
  }
</style>

<ul>
  {#each accepted as card, i}
    <li>
      <img in:fly="{{ y: 20, duration: 1000, delay: i + 160, easing: elasticOut }}" width="48" height="30" class="p-icon" src={'./' + card.toLowerCase().replace(/\s+/g, '-') + '.svg'} alt={card}>
    </li>
  {/each}
</ul>